import { ToastCheckIcon } from './Icons';

/* Bottom toast. Keeps rendering the last message while it fades out. */
export default function Toast({ toast }) {
  const cls = ['gq-toast', toast.show ? 'gq-show' : '', toast.gold ? 'gq-gold' : ''].filter(Boolean).join(' ');
  return (
    <div className={cls} role="status" aria-live="polite">
      <i><ToastCheckIcon /></i>
      <span>{toast.msg}</span>
    </div>
  );
}
